import React from 'react'
import { PumpStatusCell } from './PumpStatusGrid'

// Grid rows: top pumps / stub / missile / stub / bottom pumps. Column 1 is the wellhead.
const ROW_TOP = 1
const ROW_TOP_STUB = 2
const ROW_MISSILE = 3
const ROW_BOTTOM_STUB = 4
const ROW_BOTTOM = 5

/**
 * Pumps are parked on both sides of the missile in a U-shape:
 *   1 2 3 4
 *   -------
 *   8 7 6 5
 * Top row gets the extra pump when the count is odd.
 */
export const layoutManifoldPumps = (pumps = []) => {
  const topCount = Math.ceil(pumps.length / 2)
  return {
    columns: topCount,
    slots: pumps.map((unit, index) => {
      const isTop = index < topCount
      const column = isTop ? index + 1 : topCount - (index - topCount)
      return { unit, isTop, column }
    }),
  }
}

const PumpManifold = ({
  pumps = [],
  onSelectPump,
  treating,
  rate,
  waitingLabel = 'Waiting for data…',
  translation,
}) => {
  if (!pumps.length) {
    return <div className="fleetEmptyState">{waitingLabel}</div>
  }

  const { columns, slots } = layoutManifoldPumps(pumps)
  // +1 for the wellhead column
  const col = (column) => column + 1

  return (
    <div className="fdManifoldScroll">
      <div
        className="fdManifold"
        style={{ gridTemplateColumns: `96px repeat(${columns}, minmax(100px, 1fr))` }}
      >
        <div className="fdManifoldWellhead" style={{ gridColumn: 1, gridRow: `${ROW_TOP} / ${ROW_BOTTOM + 1}` }}>
          <span className="fdManifoldWellheadLabel">
            {translation?.fleetWellheadLabel || 'Wellhead'}
          </span>
          <div className="fdManifoldWellheadStack">
            <i className="cap" />
            <i className="stem stemTop" />
            <span className="valveRow">
              <i className="valve valveCyan" />
              <i className="arm" />
            </span>
            <i className="stem" />
            <span className="valveRow">
              <i className="arm" />
              <i className="valve valveGreen" />
            </span>
            <i className="stem" />
            <i className="base" />
            <i className="foot" />
          </div>
        </div>

        <div
          className="fdManifoldMissile"
          style={{ gridColumn: `2 / ${columns + 2}`, gridRow: ROW_MISSILE }}
        >
          <div className="fdManifoldMissileMain">
            <span className="fdManifoldFlow" aria-hidden="true">
              <span>❮</span>
              <span>❮</span>
              <span>❮</span>
            </span>
            {treating ? (
              <span className="fdManifoldReading">
                <span className="label">{translation?.fleetManifoldTreatingLabel || 'Treating'}</span>
                <b>{treating.value}</b>
                <span className="unit">{treating.unit}</span>
              </span>
            ) : null}
            {treating && rate ? <span className="fdManifoldDivider" /> : null}
            {rate ? (
              <span className="fdManifoldReading">
                <span className="label">{translation?.fleetManifoldFlowLabel || 'Downhole flow'}</span>
                <b>{rate.value}</b>
                <span className="unit">{rate.unit}</span>
              </span>
            ) : null}
          </div>
          <span className="fdManifoldMissileTag">
            ❮ {translation?.fleetToWellheadLabel || 'To wellhead'} ·{' '}
            {translation?.fleetMissileLabel || 'Missile / manifold'}
          </span>
        </div>

        {slots.map(({ unit, isTop, column }) => (
          <React.Fragment key={unit.unitUId}>
            <PumpStatusCell
              unit={unit}
              onSelectPump={onSelectPump}
              unbillableLabel={translation?.fleetUnitNotBillableLabel}
              style={{ gridColumn: col(column), gridRow: isTop ? ROW_TOP : ROW_BOTTOM }}
            />
            <div
              className="fdManifoldStub"
              style={{ gridColumn: col(column), gridRow: isTop ? ROW_TOP_STUB : ROW_BOTTOM_STUB }}
            />
          </React.Fragment>
        ))}
      </div>
    </div>
  )
}

export default PumpManifold
